/**
 * UAVTradeZone Modification Record
 *
 * Change ID:    REVIEW_USER_ABOUT_COMP
 * Date:         2025-12-29
 * Modified By:  Cursor
 *
 * Description:
 * Extracted about section for ReviewUserForm to comply with file size limits.
 * Contains user biography/description.
 *
 * File Size Check:
 * - Current: ~45 lines
 * - Limit: 200 lines
 * - Decision: New component creation (under limit)
 *
 * Related Screens / Modules:
 * - client/src/components/setup/ReviewUserForm.tsx
 */
import React from "react";
import type { User } from "../../../../interfaces/User";

interface ReviewUserAboutProps {
  profile: Partial<User> | null;
}

export const ReviewUserAbout: React.FC<ReviewUserAboutProps> = ({ profile }) => {
  return (
    <div className="review-section-block">
      <h6 className="review-section-title">
        About {profile?.firstName || "me"}
      </h6>
      <p className="review-section-text">
        {profile?.bio ||
          "Tell others a bit about yourself, your role and your experience."}
      </p>
    </div>
  );
};
